import { useTranslation } from 'react-i18next';

import { useTodaysCountry } from '../providers/TodaysCountryProvider';
import EmojiRender from './EmojiRender';

export const NextBonusRoundButton = ({
  nextBonusRoundIndex,
  width,
}: {
  nextBonusRoundIndex: number;
  width?: string;
}) => {
  const { rounds, navToRound } = useTodaysCountry();
  const { t } = useTranslation();

  return (
    <button
      onClick={() => {
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }, 250);
        navToRound(rounds[nextBonusRoundIndex]);
      }}
      className={`h-10 rounded-xl bg-green-600 hover:bg-green-700 active:bg-green-700 text-white font-semibold px-2 py-1 text-md flex items-center justify-center ${width ?? 'w-full'}`}
    >
      <EmojiRender text="🎁" className="inline-block mr-2" />
      {nextBonusRoundIndex === 1 ? t('play-bonus') : t('next-bonus')}
    </button>
  );
};
